var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectAreTooltipHidden, selectTooltipTextBuildingInfo, } from "../../selectors/selectTooltipInfo";
var Point = PIXI.Point;
import { selectIsTutorialActive } from "../../selectors/selectTutorial";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { bugsnagClient } from "../bugsnag/bugsnagClient";
import { ErrorBoundary } from "../generic/ErrorBoundary";
import { TextLoca } from "../generic/text/TextLoca";
import { ViewportWorldSpace } from "../viewport/ViewportWorldSpace";
import { IdTooltipAnchor } from "./IdTooltipAnchor";
var TooltipTextBuildingDOM = /** @class */ (function (_super) {
    __extends(TooltipTextBuildingDOM, _super);
    function TooltipTextBuildingDOM(props) {
        var _this = _super.call(this, props) || this;
        _this.renderTooltip = function (viewport, loca, replacements, level) {
            var replacementsMap = new Map([[ReplacementLoca.zero_0, level.toString()]]);
            var levelText = level !== undefined && level > 0 ? (React.createElement(TextLoca, { id: IdLoca.levelX, replacements: replacementsMap })) : (React.createElement(React.Fragment, null));
            return (React.createElement("div", { style: _this.getTooltipPosition(viewport), className: IdStyles.TextBoldPrimary + " tooltip__text tooltip__text--" + IdTooltipAnchor.Bottom + " tooltip__building flex flex--stacked" },
                React.createElement(TextLoca, { id: loca, replacements: replacements }),
                levelText));
        };
        _this.getTooltipPosition = function (viewport) {
            var position = _this.props.position;
            position = viewport.toGlobal(new Point(position.x, position.y));
            return _this.getStyle(position);
        };
        _this.getStyle = function (_a) {
            var x = _a.x, y = _a.y;
            return ({
                left: x + "px",
                position: "absolute",
                top: y + "px",
            });
        };
        return _this;
    }
    TooltipTextBuildingDOM.prototype.render = function () {
        var _this = this;
        var _a = this.props, shouldRender = _a.shouldRender, loca = _a.loca, replacements = _a.replacements, buildingLevel = _a.buildingLevel, areTooltipHidden = _a.areTooltipHidden;
        if (!shouldRender || !loca || !buildingLevel || areTooltipHidden) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement(ErrorBoundary, { client: bugsnagClient.bugsnag, name: "TooltipTextBuilding.tsx" },
            React.createElement(ViewportWorldSpace, null, function (viewport) {
                return _this.renderTooltip(viewport, loca, replacements, buildingLevel);
            })));
    };
    return TooltipTextBuildingDOM;
}(React.PureComponent));
var mapState = function (state) {
    var currentSettings = selectTooltipTextBuildingInfo(state);
    return __assign({}, currentSettings, { areTooltipHidden: selectAreTooltipHidden(state) || selectIsTutorialActive(state) });
};
export var TooltipTextBuilding = connect(mapState)(TooltipTextBuildingDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/tooltip/TooltipTextBuilding.tsx
// module id = 2324
// module chunks = 3